if (!customElements.get('hub-navigation')) {
  customElements.define('hub-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggleButton = this.querySelector('.hubnav-toggle');
      this.menu = this.querySelector('.hubnav-menu');
      this.setAttribute('data-ready', '');
      this.querySelectorAll('img').forEach(img => {
        const fallback = () => {
          img.hidden = true;
          const symbol = img.nextElementSibling;
          if (symbol?.matches('.hubnav-card-symbol')) symbol.hidden = false;
        };
        img.addEventListener('error', fallback, options);
        if (img.complete && !img.naturalWidth) fallback();
      });
      const aliases = {
        'hub-bot-family': '[id^="HubBotFamily-"]',
        'hub-creator-college': '[id$="__creator_college_family_live"]',
        'hub-experiences': '[id$="__custom_liquid_NWFyRQ"]'
      };
      Object.entries(aliases).forEach(([id, selector]) => {
        const target = document.querySelector(selector);
        if (!target || document.getElementById(id)) return;
        const marker = document.createElement('span');
        marker.id = id;
        marker.style.cssText = 'display:block;height:0;scroll-margin-top:160px';
        target.before(marker);
      });
      const scrollToAlias = () => {
        const id = location.hash.slice(1);
        if (Object.hasOwn(aliases, id)) document.getElementById(id)?.scrollIntoView({block:'start'});
      };
      window.addEventListener('load', scrollToAlias, options);
      window.addEventListener('hashchange', scrollToAlias, options);
      if (document.readyState === 'complete') scrollToAlias();
      this.toggleButton.addEventListener('click', () => this.setMenu(!this.hasAttribute('data-menu-open')), options);
      this.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('details[open]').forEach(other => {
            if (other !== details && !other.contains(details) && !details.contains(other)) other.open = false;
          });
          if (details.matches('.hubnav-search')) details.querySelector('input')?.focus();
          if (!this.menu.contains(details)) this.setMenu(false);
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const detail = event.target.closest('details[open]');
        if (detail) { detail.open = false; detail.querySelector('summary').focus(); }
        else if (this.hasAttribute('data-menu-open')) { this.setMenu(false); this.toggleButton.focus(); }
      }, options);
      document.addEventListener('click', event => {
        if (this.contains(event.target)) return;
        this.closeDetails();
        this.setMenu(false);
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) {
          this.closeDetails();
          this.setMenu(false);
        }
      }, options);
      this.addEventListener('click', event => {
        const anchor = event.target.closest('a[href]');
        if (!anchor) return;
        this.closeDetails();
        this.setMenu(false);
      }, options);
      const media = matchMedia('(min-width:1180px)');
      media.addEventListener('change', () => {this.setMenu(false);this.closeDetails();}, options);
      this.querySelectorAll('.hubnav-menu a').forEach(anchor => {
        const target = new URL(anchor.href, location.href);
        if (target.origin === location.origin && !target.hash && target.pathname === location.pathname && target.pathname !== '/') anchor.setAttribute('aria-current', 'page');
      });
    }
    setMenu(open) {
      this.toggleAttribute('data-menu-open', open);
      this.toggleButton.setAttribute('aria-expanded', String(open));
      if (open) this.querySelectorAll('.hubnav-tools details,.hubnav-utility details').forEach(d => {d.open = false;});
      else this.menu.querySelectorAll('details').forEach(d => {d.open = false;});
    }
    closeDetails() {this.querySelectorAll('details[open]').forEach(d => {d.open = false;});}
    disconnectedCallback() {this.controller?.abort();this.controller = null;}
  });
}
